module.exports = __webpack_public_path__ + "static/img/xiaochengxu.82425be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiaochengxu.jpg
// module id = 1/Bq
// module chunks = 1